import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from './core/services/auth.service';
import { LoadingService } from './core/services/loading.service';
import { IdleTimeoutService } from './core/services/idle-timeout.service';
import { MainLoadingComponent } from './shared/components/main-loading/main-loading.component';
import { PromptUpdateService } from './core/services/prompt-update.service';
import { GlobalConfigsService } from './core/services/global-configs.service';

@Component({
    selector: 'app-root',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        RouterOutlet,
        MainLoadingComponent,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
    public destroyRef = inject(DestroyRef);
    private promptUpdateService = inject(PromptUpdateService);

    constructor(
        private router: Router,
        private authService: AuthService,
        public loadingService: LoadingService,
        private modalService: NgbModal,
        private globalConfigsService: GlobalConfigsService,
        private idleTimeoutService: IdleTimeoutService
    ) {
        // Configure idle timeout from global configs
        globalConfigsService.globalConfigs$.pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe((data) => {
            if (Object.keys(data)?.length) {
                const idleTimeoutMs = data.find((el) => {
                    return el.ConfigKey === 'SessionDuration';
                })?.ConfigValue || '';

                if (idleTimeoutMs) {
                    this.idleTimeoutService.idleTimeoutMs = +idleTimeoutMs * 60 * 1000;
                    this.idleTimeoutService.checkIfExpiredOnLoad();
                }
            }
        });
    }

    async ngOnInit() {
        await this.authService.checkAuth();

        this.authService.isAuthenticated.pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe(isAuthenticated => {
            if (!isAuthenticated) {
                this.loadingService.hideLoader();
                this.idleTimeoutService.stopWatching();
            }
        });

        this.closeAllDialogs();
    }

    private closeAllDialogs(): void {
        this.router.events.pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (this.modalService.hasOpenModals()) {
                    this.modalService.dismissAll();
                }
            }
        });
    }
}
